import { z } from 'zod';

export const UserDetailsSchema = z.object({
  UserId: z.string(),
  Role: z.string().min(1, { message: 'Please select a role' }),
});

export type UserDetailsFormFields = z.infer<typeof UserDetailsSchema>;
